import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintManageEntityList } from './';

/**
 * @component {kat-blueprint-manage-entity-list-focus} KatBlueprintManageEntityListFocus Component used to place and filter components within the focus section.
 * @slot default Blueprint content for focus section.
 */
@register(KatBlueprintManageEntityList.slotMapping.focus.name)
export class KatBlueprintManageEntityListFocus extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintManageEntityList.slotMapping.focus.name,
      KatBlueprintManageEntityList.slotMapping.focus.allowed
    );
  }
}
